import styles from './popupAnnouncement.module.scss';
import {
  Form,
  Input,
  Select,
  Tabs,
  Button,
  Switch,
  Spin,
  InputNumber,
} from 'antd';
import {supportedLanguages} from 'utils/constants';
import {PlusOutlined, MinusCircleOutlined} from '@ant-design/icons';

export const StepThreePopupAnnouncement = ({
  form,
  popup,
  popupAnnouncement,
}) => {
  const {type, language: rootLanguage} = popupAnnouncement;
  const announcements = Form.useWatch('announcements', form) || [];
  const {Option} = Select;
  const {
    handleUploadAudio,
    handleUploadVideo,
    handleUploadImage,
    clearAudioFile,
    clearVideoFile,
    clearImageFile,
    handleTranslation,
    loadingTranslation,
  } = popup;

  // Deprecated in favor of renderTextFields helper

  const renderImageUpload = (field, multilang = false) => {
    const currentImageUrl = multilang
      ? announcements?.[field.name]?.multilang?.imageUrl
      : announcements?.[field.name]?.imageUrl;
    const loadingImageUpload = multilang
      ? announcements?.[field.name]?.multilang?.loadingImageUpload
      : announcements?.[field.name]?.loadingImageUpload;
    const imageProgress = multilang
      ? announcements?.[field.name]?.multilang?.imageProgress
      : announcements?.[field.name]?.imageProgress;

    if (currentImageUrl) {
      return (
        <div className={styles.audioFileContainer}>
          <img
            src={currentImageUrl}
            alt="announcement cover"
            style={{width: '100%', borderRadius: 8, marginBottom: 8}}
          />
          <Button
            onClick={() => clearImageFile(field.name, multilang)}
            size="small"
            danger>
            Delete Image
          </Button>
        </div>
      );
    }

    return (
      <div className={styles.audioUploadContainer}>
        <label
          className={styles.audioUploadLabel}
          htmlFor={`image-upload-${field.name}-${multilang ? 'ml' : 'orig'}`}>
          {loadingImageUpload ? (
            <div className={styles.uploading}>
              <Spin size="small" />
              <span>Uploading... {imageProgress || 0}%</span>
            </div>
          ) : (
            <div className={styles.audioUploadContent}>
              <span>Upload Image</span>
            </div>
          )}
          <input
            type="file"
            id={`image-upload-${field.name}-${multilang ? 'ml' : 'orig'}`}
            accept="image/*"
            className={styles.inputFile}
            onChange={e => handleUploadImage(e, field.name, multilang)}
          />
        </label>
      </div>
    );
  };

  const renderAudioUpload = (field, multilang = false) => {
    const currentAudioFileUrl = announcements?.[field.name]?.audioFile;
    const currentMultilangAudioFile =
      announcements?.[field.name]?.multilang?.audioFile;

    const currentAudioFile = multilang
      ? currentMultilangAudioFile
      : currentAudioFileUrl;

    if (currentAudioFile) {
      return (
        <div className={styles.audioFileContainer}>
          <audio
            controls
            src={currentAudioFile}
            style={{width: '100%', marginBottom: '8px'}}
          />
          <Button
            onClick={() => clearAudioFile(field.name, multilang)}
            size="small"
            danger>
            Delete Audio
          </Button>
        </div>
      );
    }

    return (
      <div className={styles.audioUploadContainer}>
        <label
          className={styles.audioUploadLabel}
          htmlFor={`audio-upload-${field.name}`}>
          {announcements[field.name]?.loadingAudioUpload ||
          (multilang &&
            announcements[field.name]?.multilang?.loadingAudioUpload) ? (
            <div className={styles.uploading}>
              <Spin size="small" />
              <span>
                Uploading...{' '}
                {multilang
                  ? announcements[field.name]?.multilang?.audioProgress || 0
                  : announcements[field.name]?.audioProgress || 0}
                %
              </span>
            </div>
          ) : (
            <div className={styles.audioUploadContent}>
              <span>Upload Audio</span>
            </div>
          )}
          <input
            type="file"
            id={`audio-upload-${field.name}`}
            accept="audio/mpeg"
            className={styles.inputFile}
            onChange={e => handleUploadAudio(e, field.name, multilang)}
          />
        </label>
      </div>
    );
  };

  const renderVideoUpload = (field, multilang = false) => {
    const currentVideoUrl = multilang
      ? announcements?.[field.name]?.multilang?.videoUrl
      : announcements?.[field.name]?.videoUrl;
    const useVideoUrlFlag = announcements?.[field.name]?.useVideoUrl || false;
    const useMultilangVideoUrlFlag =
      announcements?.[field.name]?.useMultilangVideoUrl || false;

    const useVideoUrl = multilang ? useMultilangVideoUrlFlag : useVideoUrlFlag;

    return (
      <div>
        <Form.Item label="Use Video Url" className={styles.fieldWidth}>
          <Switch
            checked={useVideoUrl}
            onChange={checked => {
              const current = announcements || [];
              current[field.name] = {
                ...(current[field.name] || {}),
                ...(multilang
                  ? {useMultilangVideoUrl: checked}
                  : {useVideoUrl: checked}),
              };
              form.setFieldsValue({announcements: current});
            }}
          />
        </Form.Item>
        {useVideoUrl ? (
          <Form.Item
            label="Video URL"
            className={styles.fieldWidth}
            name={[field.name, multilang ? 'multilangVideoUrl' : 'videoUrl']}>
            <Input placeholder="Enter video URL" />
          </Form.Item>
        ) : (
          <div>
            {currentVideoUrl ? (
              <div className={styles.videoFileContainer}>
                <video
                  controls
                  width="100%"
                  src={currentVideoUrl}
                  style={{marginBottom: '8px'}}
                />
                <Button
                  onClick={() => clearVideoFile(field.name, multilang)}
                  size="small"
                  danger>
                  Delete Video
                </Button>
              </div>
            ) : (
              <div className={styles.videoUploadContainer}>
                <label
                  className={styles.videoUploadLabel}
                  htmlFor={`video-upload-${field.name}`}>
                  {announcements[field.name]?.loadingVideoUpload ? (
                    <div className={styles.uploading}>
                      <Spin size="small" />
                      <span>
                        Uploading...{' '}
                        {multilang
                          ? announcements[field.name]?.multilang
                              ?.videoProgress || 0
                          : announcements[field.name]?.videoProgress || 0}
                        %
                      </span>
                    </div>
                  ) : (
                    <div className={styles.videoUploadContent}>
                      <span>Upload Video</span>
                    </div>
                  )}
                  <input
                    type="file"
                    id={`video-upload-${field.name}`}
                    accept="video/mp4"
                    className={styles['input-file']}
                    onChange={e => handleUploadVideo(e, field.name, multilang)}
                  />
                </label>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const renderTextFields = (field, multilang = false) => {
    const scope = multilang ? ['multilang'] : [];
    return (
      <>
        <Form.Item
          label="Title"
          className={styles.fieldWidth}
          name={[field.name, ...scope, 'title']}>
          <Input
            placeholder={multilang ? 'Enter translated title' : 'Enter title'}
          />
        </Form.Item>
        <Form.Item
          label="Subtitle"
          className={styles.fieldWidth}
          name={[field.name, ...scope, 'subTitle']}>
          <Input.TextArea
            rows={5}
            placeholder={
              multilang ? 'Enter translated subtitle' : 'Enter subtitle'
            }
          />
        </Form.Item>
        <Form.Item
          name={[field.name, ...scope, 'actionButtonText']}
          label="Action Button Text"
          tooltip="The text to be displayed on the action button"
          rules={[{max: 20, message: 'Max 20 characters'}]}
          className={styles.fieldWidth}>
          <Input
            placeholder={
              multilang
                ? 'Enter translated action button text'
                : 'Enter action button text'
            }
            max={20}
          />
        </Form.Item>
      </>
    );
  };

  const renderAnnouncementFields = field => {
    switch (type) {
      case 'AUDIO': {
        const selectedTranslationLanguage =
          announcements?.[field.name]?.translation;
        const originalTitle = announcements?.[field.name]?.title;
        const originalSubTitle = announcements?.[field.name]?.subTitle;
        const originalActionButtonText =
          announcements?.[field.name]?.actionButtonText;
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                selectedTranslationLanguage ? (
                  <Button
                    disabled={
                      !originalTitle || !originalSubTitle || loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        selectedTranslationLanguage,
                        originalTitle,
                        originalSubTitle,
                        originalActionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                {renderAudioUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    {renderAudioUpload(field, true)}
                    <Form.Item
                      label="Translated Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'VIDEO': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                {renderVideoUpload(field)}
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    {renderVideoUpload(field, true)}
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'GENERAL':
      case 'SIMULATOR': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderImageUpload(field, true)}
                    {renderTextFields(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'EVENT': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'SINGLE_REPORT': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'SINGLE_STOCK':
      case 'SINGLE_BOND':
      case 'SINGLE_MUTUAL_FUND':
      case 'SINGLE_COLLECTION':
      case 'SINGLE_OPPORTUNITY': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      className={styles.fieldWidth}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'SUBSCRIPTION': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'OPPORTUNITY_LISTING': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'NEW_REPORT': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      !announcements?.[field.name]?.actionButtonText ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  rules={[{type: 'url', message: 'Please input a valid URL'}]}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'SAVINGS': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      !announcements?.[field.name]?.actionButtonText ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      className={styles.fieldWidth}
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'REWARD': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      !announcements?.[field.name]?.actionButtonText ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      className={styles.fieldWidth}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      case 'LEADERBOARD': {
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      !announcements?.[field.name]?.actionButtonText ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
      }
      default:
        return (
          <>
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                announcements[field.name]?.translation ? (
                  <Button
                    disabled={
                      !announcements?.[field.name]?.title ||
                      !announcements?.[field.name]?.subTitle ||
                      !announcements?.[field.name]?.actionButtonText ||
                      loadingTranslation
                    }
                    onClick={() =>
                      handleTranslation(
                        field.name,
                        rootLanguage,
                        announcements[field.name]?.translation,
                        announcements?.[field.name]?.title,
                        announcements?.[field.name]?.subTitle,
                        announcements?.[field.name]?.actionButtonText,
                      )
                    }>
                    Translate
                  </Button>
                ) : null
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {renderTextFields(field)}
                {renderImageUpload(field)}
                <Form.Item
                  label="Announcement URL"
                  className={styles.fieldWidth}
                  name={[field.name, 'announcementUrl']}>
                  <Input placeholder="Enter announcement URL" />
                </Form.Item>
              </Tabs.TabPane>
              {announcements[field.name]?.translation && (
                <Tabs.TabPane
                  key={announcements[field.name]?.translation}
                  tab={
                    supportedLanguages.find(
                      lang =>
                        lang.value === announcements[field.name]?.translation,
                    )?.label || announcements[field.name]?.translation
                  }>
                  <div>
                    {renderTextFields(field, true)}
                    {renderImageUpload(field, true)}
                    <Form.Item
                      label="Announcement URL"
                      rules={[
                        {type: 'url', message: 'Please input a valid URL'},
                      ]}
                      className={styles.fieldWidth}
                      name={[field.name, 'multilang', 'announcementUrl']}>
                      <Input placeholder="Enter translated announcement URL" />
                    </Form.Item>
                  </div>
                </Tabs.TabPane>
              )}
            </Tabs>
          </>
        );
    }
  };

  return (
    <div className={styles.stepThreeContainer}>
      <h2>Create Announcement Content</h2>
      <p>
        Configure the content for your popup announcement. You can add multiple
        announcements and customize them with translations.
      </p>
      <Form.List name="announcements">
        {(fields, {add, remove}) => (
          <>
            {fields.map(field => (
              <div key={field.key} className={styles.announcementItem}>
                <div className={styles.announcementHeader}>
                  <h3>Announcement {field.name + 1}</h3>
                  <MinusCircleOutlined
                    className={styles.removeButton}
                    onClick={() => remove(field.name)}
                  />
                </div>

                <Form.Item
                  name={[field.name, 'dismissible']}
                  label="Dismissible?"
                  tooltip="The User can be allowed to dismiss the popup">
                  <Switch />
                </Form.Item>
                <Form.Item
                  name={[field.name, 'maxShowCount']}
                  label="Max Show Count"
                  tooltip="Number of times the popup can be shown to the user">
                  <InputNumber min={1} className="input-number" />
                </Form.Item>
                <Form.Item
                  label="Language Translation"
                  className={styles.fieldWidth}
                  name={[field.name, 'translation']}>
                  <Select allowClear>
                    {supportedLanguages
                      .filter(l => l.value !== rootLanguage)
                      .map(data => (
                        <Option key={data.value} value={data.value}>
                          {data.label}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                {renderAnnouncementFields(field)}
              </div>
            ))}
            <div className={styles.addButtonContainer}>
              <Button
                type="dashed"
                onClick={() => add()}
                icon={<PlusOutlined />}
                className={styles.addButton}>
                Add Another Announcement
              </Button>
            </div>
          </>
        )}
      </Form.List>
    </div>
  );
};
